import { useDraggable } from "@dnd-kit/core";
import { nanoid } from "nanoid";
import { useRef } from "react";

import { fields } from "./fields";
import { cn } from "@/lib/utils";

export function SidebarField({field}:{field:any}) {
  return (
    <div className={cn(
      "flex items-center h-10 gap-2 px-3 py-2 text-sm font-medium border rounded-sm hover:bg-muted"
      )}>
      {field?.icon}
      <p>{field?.title || ''}</p>
    </div>
  );
}

function DraggableSidebarField(props:any) {
  const { field } = props;

  const id = useRef(nanoid());

  const { attributes, listeners, isDragging, setNodeRef } = useDraggable({
    id: id.current,
    data: {
      field,
      fromSidebar: true,
    },
  });

  return (
    <div ref={setNodeRef} {...listeners} {...attributes} className={cn("cursor-grab", isDragging && "opacity-50")}>
      <SidebarField field={field} />
    </div>
  );
}

export default function Sidebar(props:any) {
  const { fieldsRegKey } = props;

  return (
    <div key={fieldsRegKey} className="p-3 overflow-auto border rounded-md shadow-md w-80 min-w-80 bg-background">
      <div className="flex flex-col gap-2">
        {fields.map((f) => (
          <DraggableSidebarField key={f.type} field={f} />
        ))}
      </div>
    </div>
  );
}
